import React, { useEffect, useState } from "react";


import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Spin from 'antd/lib/spin';
import Pagination from 'antd/lib/pagination';
import { Table, Tag, Space } from 'antd';
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import AppService from './../../../../../service/app_service'
import AuthenticationService from './../../../../../service/authentication_service'
import UrlService from './../../../../../service/url_service'
import TopBarComponent from './../../../component/topbar_component'
import ModalComponent from './../../../component/modal_component'
import SockJsClient from 'react-stomp';
import { PaystackButton } from "react-paystack"

var interval = null;
var downloadTimer = null;
const AirtimeDetailPage = (props) => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState(0);
    const [order, setOrder] = useState(null);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);

    const [showGiveawayModal, setShowGiveawayModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [paymentSuccessful, setPaymentSuccessful] = useState(false);
    const [action, setAction] = useState(null);
    const [amount, setAmount] = useState(0);
    const [giveawayAmount, setGiveawayAmount] = useState(0);
    const [phoneNumber, setPhoneNumber] = useState(0);
    const [network, setNetwork] = useState('MTN');
    const [giveawayQuantity, setGiveawayQuantity] = useState(0);
    const [giveawayUseDice, setGiveawayUseDice] = useState(0);
    const [giveawayRewardType, setGiveawayRewardType] = useState('airtime');
    const [giveawayGameType, setGiveawayGameType] = useState('fastestFinger');
    const [giveawayRewardPosition, setGiveawayRewardPosition] = useState('highest');
    const [inputOpenFileRef, setInputOpenFileRef] = useState(React.createRef());
    const [giveaways, setGiveaways] = useState([]);
    const [clientRef, setClientRef] = useState(null);
    const [orderRef, setOrderRef] = useState((new Date()).getTime().toString());

    const [channel, setChannel] = useState(null);
    const [email, setEmail] = useState(AuthenticationService.getEmail());
    const [name, setName] = useState(AuthenticationService.getName());
    const [phone, setPhone] = useState(AuthenticationService.getMobileNumber());
    const [publicKey, setPublicKey] = useState('pk_test_2372fc72b7cb8c49bab910c839370a2bbbc855b4');
    const [paystackAmount, setPaystackAmount] = useState(9000);


    const [totalAmount, setTotalAmount] = useState(0);
    const [items, setItems] = useState([]);
    const [errorCount, setErrorCount] = useState(0);
    const [page, setPage] = useState(1);
    const [paginationSize, setPaginationSize] = useState(25);


    useEffect(() => {
        setChannel(channelGenerator());
        getTransactions(pageNumber);
        console.log(props.match.params.orderRef)
        //eslint-disable-next-line

    }, []);

    const getTransactions = async (pageNumber) => {
        setLoading(true);
        if ('ALL' === props.match.params.orderRef) {
            AppService.getMyGiveaways(pageSize, pageNumber).then(rec => {
                setLoading(false)
                if (rec.error) {
                    // AuthenticationService.clearLocalstorage();
                    // this.props.history.push('/');
                } else {
                    setTransactions(rec.list);
                    setPaginationSize(rec.list.length);
                    if (rec && rec.list) {
                        //setTotalTransactionCount(rec.list.length);
                    }
                }
            })
        } else {
            AppService.getMyGiveawaysByRef(pageSize, pageNumber, props.match.params.orderRef).then(rec => {
                setLoading(false)
                if (rec.error) {
                    // AuthenticationService.clearLocalstorage();
                    // this.props.history.push('/');
                } else {
                    setTransactions(rec.list)
                    if (rec && rec.list) {
                        //setTotalTransactionCount(rec.list.length);
                    }
                }
            })
        }

        AppService.getOrderByRef(props.match.params.orderRef).then(rec => {
            setLoading(false)
            if (rec.error) {

            } else {
                setOrder(rec)
            }
        })

    }

    const changePage = (val) => {
        setPageNumber(val)
        getTransactions(val);
    }

    const submitAirtimeDisbursement = () => {
        //giveaway:qty_amount,qty_amount,qty_amount
        let arr = items.map(item => (item.amount + '_1_' + item.phoneNumber + '_' + item.network));
        let codedMessage = "airtime:" + arr.toString();
        console.log(codedMessage);
        let data = {};
        data.items = items;
        data.codedMessage = codedMessage;
        data.orderRef = props.match.params.orderRef;
        data.message = "AIRTIME_DISBURSEMENT";
        setLoading(true);
        AppService.submitAirtimeDisbursement(data).then(rec => {

            setLoading(false);
            if (!rec.code) {
                message.success("Record submitted successfully.");
                setShowGiveawayModal(false);
                getTransactions(pageNumber);
                setItems([])

            } else {
                message.error(rec.description);
            }

        })
    };

    const startAirtimeDisbursement = () => {
        let data = {};
        data.orderRef = props.match.params.orderRef;
        setLoading(true);
        AppService.startAirtimeDisbursement(data).then(rec => {

            setLoading(false);
            if (!rec.code) {
                message.success("Order disbursement initiated successfully.");
                getTransactions(pageNumber);

            } else {
                message.error(rec.description);
            }

        })
    };

    const getDirectGiveawayRedeemption = (id) => {
        setLoading(true);
        AppService.getDirectGiveawayRedeemption(id).then(rec => {

            setLoading(false);
            if (rec.code === "200") {
                message.success("Airtime redeemed successfully.");
                getTransactions(pageNumber);

            } else {
                message.error(rec.message);
            }

        })
    };



    const config = {
        reference: orderRef,
        email: email,
        amount: paystackAmount,
        publicKey: publicKey,
        metadata: {
            name: name,
            phone: phone,
        }
    };

    const componentProps = {
        ...config,
        publicKey,
        text: "Pay Now",
        onSuccess: () => {
            verifyPaystackPayment();
        },
        onClose: () => alert("Wait! Don't leave :("),
    }

    const setAmountState = (amount) => {
        setAmount(amount);
        setPaystackAmount(100 * (amount + (200 + (1.5 * amount / 100))));
    }

    const verifyPaystackPayment = () => {
        let arr = giveaways.map(item => (item.amount + '_' + item.quantity + '_' + item.useDice + '_' + item.duration));
        let codedMessage = "giveaway:" + arr.toString();
        let data = {};
        data.xo = AuthenticationService.getToken();
        data.emailAddress = AuthenticationService.getEmail();
        data.channel = channel;
        data.amount = amount;
        data.reference = orderRef;
        data.codedMessage = codedMessage;
        data.message = "GIVEAWAY";
        console.log("data:", data);
        AppService.paystackPaymentConfirmation(data).then(rec => {

            setLoading(false);
            if (!rec.code) {
                message.success("Payment successful, Giveaway generation in progress.");
                setOrderRef((new Date()).getTime().toString());
                setShowGiveawayModal(false);
                getTransactions(pageNumber);

            } else {
                message.error(rec.description);
            }

        })
    };

    const handleChange = (e) => {
        if (e.target.name === 'amount') {
            setAmount(parseFloat(e.target.value));
        } else if (e.target.name === 'network') {
            setNetwork(e.target.value);
        } else if (e.target.name === 'phoneNumber') {
            setPhoneNumber(e.target.value);
        }

    }


    const channelGenerator = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    const addMoreGiveaway = () => {
        if (amount > 0 && phoneNumber && network) {

            let data = {};
            data.id = channelGenerator();
            data.quantity = 1;
            data.amount = amount;
            data.useDice = 0;
            data.duration = 0;
            data.gameType = giveawayGameType;
            data.rewardType = giveawayRewardType;
            data.rewardPosition = giveawayRewardPosition;
            data.network = network;
            data.phoneNumber = phoneNumber;
            data.errorMessage = "";
            items.push(data);

            setItems(items);
            calculateTotal(items);

            setAmount(0);
            setPhoneNumber('');
            setAmount(0);

        } else {
            alert("Missing phone number or network or amount.");
        }

    };

    const removeGiveaway = (id) => {
        let result = items.filter(function (obj) {
            return obj.id !== id;
        });
        setItems(result);
        calculateTotal(result);
    };

    const calculateTotal = (items) => {
        let amt = items.length > 0 ? items.map(item => (item.amount * item.quantity)).reduce((prev, next) => prev + next) : 0;
        setTotalAmount(amt);
    }

    const onChangeHandler = event => {

        setTotalAmount(null);
        setErrorCount(null);
        setItems(null);
        let data = {
            upload: event.target.files[0]
        }
        AppService.uploadAirtimeSheet(data)
            .then(response => {
                if (response.code) {

                } else {
                    setTotalAmount(response.totalAmount);
                    setErrorCount(response.errorCount);
                    setItems(response.items);
                    console.log(response);
                }
            })

    }

    const formatAmount = (amount) => {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    const uploadBeneficiary = (modal, action) => {
        setShowGiveawayModal(modal);
        setAction(action);
    }


    const showRecord = () => {
        setShowModal(!showModal);
        setShowGiveawayModal(!showGiveawayModal);
    }

    const columns = [
        {
            title: 'Phone Number',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            render: (text) => <div>{text}</div>,
            width: 150,
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            width: 100,
        },
        {
            title: 'Network',
            dataIndex: 'network',
            key: 'network',
            width: 100,
        },
        {
            title: 'Error',
            key: 'errorMessage',
            render: (record, i) => (
                <span>
                    <Tag color={record.hasError ? 'red' : 'green'} key={i}>
                        {record.errorMessage.toUpperCase()}
                    </Tag>
                </span>
            ),
        },
    ];

    const columnsSingleList = [
        {
            title: 'S/N',
            dataIndex: 'serial',
            key: 'serial',
            render: (value, text, index) => <div>{index+1}</div>,
            width: 70,
        },
        {
            title: 'Phone Number',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            render: (text) => <div>{text}</div>,
            width: 150,
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            width: 100,
        },
        {
            title: 'Network',
            dataIndex: 'network',
            key: 'network',
            width: 100,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <i className="fas fa-trash" onClick={() => removeGiveaway(record.id)} />
            ),
            width: 100,
        },
    ];


    const beneficiariesColumn = [
        {
            title: 'S/N',
            key: 'number',
            render: (text, record, index) => (page - 1) * paginationSize + index + 1,
            fixed: 'left',
            width: 70,
        },
        {
            title: 'Phone Number',
            dataIndex: 'givenToPhoneNumber',
            key: 'givenToPhoneNumber',
            render: (text) => <div>{text}</div>,
            width: 150,
        },
        {
            title: 'Network',
            dataIndex: 'givenToNetwork',
            key: 'givenToNetwork',
            width: 100,
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            width: 100,
        },
        {
            title: 'Status',
            key: 'status',
            render: (record, i) => (
                <span>
                    {record.hasError === 0 && <Tag color={record.givenAway ? 'green' : 'yellow'} key={i}>
                        {record.givenAway ? 'REDEEMED' : 'PENDING'}
                    </Tag>}
                    {record.hasError === 1 && <Tag color={record.givenAway ? 'green' : 'red'} key={i}>
                        {record.errorMessage.toUpperCase()}
                    </Tag>}
                </span>
            ),
            width: 150,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    {!record.givenAway && <Popconfirm
                        title="Are you sure to redeem this airtime manually?"
                        onConfirm={() => getDirectGiveawayRedeemption(record.uid)}
                        okText="Yes"
                        cancelText="No"
                    >
                        
                        <a ><Tag color="#2db7f5">Redeem</Tag></a>
                    </Popconfirm>}
                    <br />
                    {/* {!record.givenAway && <a href={'/' + record.id}>Block</a>} */}
                </Space>
            ),
            width: 150,
        },
    ];

    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3', minHeight: '700px' }} >
            <TopBarComponent />
            <Spin spinning={loading}>
                <div className="page-content">
                    <div className="container">
                        <div className="card content-area">
                            <div className="card-innr">
                                <div className="card-head" style={{ width: '100%' }}>
                                    {order && <h3 className="schedule-title"><span>{order.description} : {props.match.params.orderRef}</span><span className="badge badge-success ucap badge-xs" style={{ height: '18px' }} >{order.status}</span> <em className="text-primary ti ti-reload" style={{ paddingLeft: '15px' }} onClick={() => getTransactions(pageNumber)} /></h3>}

                                    <div style={{ float: 'right', margin: '10px 0px', width: 'auto' }}>
                                        <Link to="/airtime/disbursement" className="btn btn-sm btn-auto btn-primary d-sm-block d-none"><em className="fas fa-arrow-left mr-3" />Back</Link>
                                        <Link to="/airtime/disbursement" className="btn btn-icon btn-sm btn-primary d-sm-none"><em className="fas fa-arrow-left" /></Link>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="token-statistics card card-token height-auto">
                                            <div className="card-innr">
                                                <div className="token-balance token-balance-with-icon">
                                                    <div className="token-balance-icon"><img src="/assets/images/logo-light-sm.png" alt="logo" /></div>
                                                    <div className="token-balance-text">
                                                        <h6 className="card-sub-title">Estimated Amount</h6>
                                                        <span className="lead">&#8358; {order && order.totalAmount && formatAmount(order.totalAmount)} <span></span></span>
                                                    </div>
                                                    <div className="token-balance-text" style={{marginLeft: '20px'}}>
                                                        <h6 className="card-sub-title"> Total Beneficiaries</h6>
                                                        <span className="lead">{transactions &&  transactions.length} <span></span></span>
                                                    </div>
                                                </div>
                                                <div className="token-balance token-balance-s2">
                                                    <h6 className="card-sub-title">Airtime Volume</h6>
                                                    <ul className="token-balance-list">
                                                        <li className="token-balance-sub"><span className="lead">&#8358; {order && formatAmount(order.totalAirtimeAmount)}</span><span className="sub">TOTAL</span></li>
                                                        <li className="token-balance-sub"><span className="lead">&#8358; {order && formatAmount(order.totalAmountUsed)}</span><span className="sub">DISBURSED</span></li>
                                                        <li className="token-balance-sub"><span className="lead">&#8358; {order && formatAmount(order.totalAirtimeAmount - order.totalAmountUsed)}</span><span className="sub">REMAINING</span></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="content-area card" style={{ width: '100%' }}>
                                    <div className="card-innr">

                                        <div className="card-head">
                                            <h4 className="card-title">Airtime Disbursement</h4>
                                        </div>
                                        <p>
                                            You can add beneficiaries in bulk or manually one at a time.
                                        </p>

                                        <p>
                                            Below are the list of beneficiaries for this order. You can manually redeem the airtime for
                                            a beneficiary or block a beneficiary from benefiting.
                                        </p>
                                        <div className="pay-buttons">
                                            <div className="pay-button">
                                                <a onClick={() => uploadBeneficiary(true, 'Bulk')} className="btn btn-light-alt btn-between w-100">Upload Bulk Airtime Sheet</a>
                                            </div>
                                            <div className="pay-button-sap">or</div>
                                            <div className="pay-button">
                                                <a onClick={() => uploadBeneficiary(true, 'Single')} className="btn btn-light-alt btn-between w-100">Manual Upload</a>
                                            </div>
                                        </div>
                                        <div className="pay-buttons">
                                            {order && order.status !== "AIRTIME_DISBURSEMENT" && <div className="pay-button">
                                                {<Popconfirm
                                                    title="Are you sure to Start Disbursement?"
                                                    onConfirm={() => startAirtimeDisbursement()}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <a className="btn btn-light-alt btn-between w-100">Start Disbursement</a>
                                                </Popconfirm>}

                                            </div>}
                                        </div>
                                        <div style={{ float: 'right', margin: '5px 0px', width: '100%' }}>
                                            {order && order.status === "COMPLETED" && (order.totalAirtimeAmount - order.totalAmountUsed) > 0 && <h4 className="kyc-alert text-danger">* This order has pending disbursement. Click on "Start Disbursement" to resume airtime disbursement</h4>}
                                        </div>
                                        {/* <button onClick={() => copyAllGiveawayLinks()} ><span className={"tnx-type-md badge badge-outline badge-success badge-md"} >Copy ALL Links</span></button> */}
                                    </div>
                                </div>




                                {order && <div className="token-bonus-ui">
                                    <div className="bonus-bar">
                                        <div className="bonus-base" >
                                            <span className="bonus-base-title">Disbursement</span>
                                            <span className="bonus-base-amount"></span>
                                            <span className="bonus-base-percent"></span>
                                        </div>
                                        <div className="bonus-extra">
                                            {(order.totalAmountUsed !== order.totalAirtimeAmount) && <div className="bonus-extra-item active" data-percent={(100 * (order.totalAmountUsed) / order.totalAirtimeAmount)} style={{ width: (100 * (order.totalAmountUsed) / order.totalAirtimeAmount) + '10%' }}>
                                                <span className="bonus-extra-amount">&#8358; {order.totalAmountUsed}</span>
                                                <span className="bonus-extra-percent">{(100 * (order.totalAmountUsed) / order.totalAirtimeAmount).toFixed(0)}%</span>
                                            </div>}
                                            {order.totalAirtimeAmount !== order.totalAmountUsed && <div className="bonus-extra-item" data-percent={100 - (100 * (order.totalAmountUsed) / order.totalAirtimeAmount)} style={{ width: (100 - (100 * (order.totalAmountUsed) / order.totalAirtimeAmount)) + '%' }}>
                                                <span className="bonus-extra-amount">&#8358; {order.totalAirtimeAmount}</span>
                                                <span className="bonus-extra-percent">100%</span>
                                            </div>}
                                            {/* <div className={"bonus-extra-item" + (order.totalAmountUsed === order.totalAirtimeAmount) ? " active" : ""} data-percent={(order.totalAmountUsed === order.totalAirtimeAmount) ? 100 : (100 - (100 * (order.totalAmountUsed) / order.totalAirtimeAmount))} style={{ width: ((order.totalAmountUsed === order.totalAirtimeAmount) ? '100' : (100 - (100 * (order.totalAmountUsed) / order.totalAirtimeAmount))) + '%' }}>
                                                <span className="bonus-extra-amount">&#8358; {order.totalAirtimeAmount}</span>
                                                <span className="bonus-extra-percent">100%</span>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>}

                                {transactions && transactions.length > 0 && <Table columns={beneficiariesColumn}
                                    dataSource={transactions}
                                    bordered
                                    pagination={{
                                        pageSize: items.length,
                                    }}
                                    scroll={{ y: 240, }} />}
                                {transactions && transactions.length > 0 && <tr>
                                    <Pagination onChange={changePage} pageSize={transactions.length} defaultCurrent={pageNumber} current={pageNumber} total={transactions.length} />
                                </tr>}


                            </div>
                            {/* .card-innr */}
                        </div>
                        {/* .card */}
                    </div>
                    {/* .container */}
                </div>
            </Spin>
            {showModal && <div><ModalComponent show={showModal} zIndex="1" closeModal={() => showRecord()} title="Records" >
                <Spin spinning={loading}>
                    <div>

                        {items && items.length > 0 && <div>
                            
                            <div className="row">
                                <div className="col-md-24" style={{ marginTop: '10px' }}>
                                    {action === 'Single' && <Table columns={columnsSingleList}
                                        dataSource={items}
                                        pagination={{
                                            pageSize: items.length,
                                        }}
                                        scroll={{ y: 240, }} />}
                                    {action !== 'Single' && <Table columns={columns}
                                        dataSource={items}
                                        pagination={{
                                            pageSize: items.length,
                                        }}
                                        scroll={{ y: 240, }} />}
                                    
                                </div>
                            </div>
                        </div>}

                    </div>
                </Spin>
            </ModalComponent></div>}

            {showGiveawayModal && <ModalComponent show={showGiveawayModal} zIndex="20" closeModal={() => setShowGiveawayModal(!showGiveawayModal)} title="Add Beneficiary" >
                <div>
                    <Spin spinning={loading}>
                        {action === "Bulk" && <div className="row">
                            <div className="col-md-24">
                                <div className="input-item input-with-label">
                                    <label className="input-item-label">
                                        Upload Bulk Excel Sheet
                                        <br />
                                        <a target={"_blank"} href="https://docs.google.com/spreadsheets/d/1KtjjzyX0MZkf3qIacACvqxOlyiREZut7K3P-rgmrqio/edit?usp=sharing" >View Sample</a>
                                    </label>
                                    <input type="file" id="file" ref={inputOpenFileRef} style={{ display: "block" }} onChange={onChangeHandler} />
                                </div>
                            </div>
                            <div className="col-md-6">
                            </div>

                            <hr />
                            <br />
                            <br />
                            <br />


                            {items && items.length > 0 && <div className="col-md-12">
                                <h6>Record Count = {items.length}</h6>
                                <h6>Total Amount = &#8358; {formatAmount(totalAmount)}</h6>
                                {errorCount > 0 && <h6>Error count = {errorCount}</h6>}


                                <div className="gaps-3x" />
                                <button className="btn btn-primary" style={{ float: 'right', marginBottom: '10px' }} onClick={() => setShowModal(!showModal)} >View Records</button>

                                {<Popconfirm
                                    title="Are you sure to submit this?"
                                    onConfirm={submitAirtimeDisbursement}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Submit</button>
                                </Popconfirm>}
                            </div>}


                        </div>}

                        {action === "Single" && <div className="row scroll-modal" >
                            <div className="col-md-6">
                                <div className="input-item input-with-label">
                                    <label className="input-item-label">Phone Number</label>
                                    <input type="text" name="phoneNumber" value={phoneNumber} className="input-bordered" placeholder="Phone number" onChange={handleChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-with-label">
                                    <label className="input-item-label">Amount</label>
                                    <input type="number" name="amount" value={amount} className="input-bordered" placeholder="Amount" onChange={handleChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-with-label">
                                    <label htmlFor="nationality" className="input-item-label">Network</label>
                                    <select className="input-bordered" name="network" id="network" onChange={handleChange} >
                                        <option value="MTN">MTN</option>
                                        <option value="GLO">GLO</option>
                                        <option value="AIRTEL">AIRTEL</option>
                                        <option value="ETISALAT">ETISALAT</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <button className="btn btn-primary" style={{ float: 'right' }} onClick={() => addMoreGiveaway()} >Add</button>
                            </div>


                            {/* <div className="col-md-12" style={{ marginTop: '10px' }}>
                                {items && items.length > 0 && <div>

                                <div className="row">
                                    <div className="col-md-24" style={{ marginTop: '10px' }}>
                                        <Table columns={columnsSingleList}
                                            dataSource={items}
                                            pagination={{
                                                pageSize: items.length,
                                            }}
                                            scroll={{ y: 240, }} />
                                    </div>
                                </div>
                                </div>}
                                <div className="row">
                                    {items && items.length > 0 && items.map((item, i) => {
                                        let hint = "";
                                        if (item.rewardType === 'airtime') {
                                            hint = hint + "Note : participants will be rewarded with airtime.";
                                        } else {
                                            hint = hint + "Note : participants will be rewarded with cash.";
                                        }
                                        return <div className="col-md-6" key={i} style={{ boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px', paddingRight: '5px' }} >
                                            <div className="kyc-info card">
                                                <div className="card-innr">
                                                    <div className="-">Amount : <strong>&#8358; {formatAmount(item.amount)}</strong> </div>
                                                    <div className="">Phone Number       : <strong>{item.phoneNumber}</strong> </div>
                                                    <div className="">Network       : <strong>{item.network}</strong> </div>
                                                    <div className="">Amount       : <strong>&#8358; {formatAmount(item.amount)}</strong> </div>
                                                    <div className="">Delete       : <i className="fas fa-trash" onClick={() => removeGiveaway(item.id)} /></div>
                                                    <h6 className="kyc-alert text-danger">* {hint}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div> */}

                            <hr />
                            <br />
                            <br />
                            <br />


                            {items && items.length > 0 && <div className="col-md-12">
                                <h5>Record Count = {items.length}</h5>
                                <h5>Total Amount = &#8358; {formatAmount(totalAmount)}</h5>
                                {errorCount > 0 && <h6>Error count = {errorCount}</h6>}


                                <div className="gaps-3x" />
                                <button className="btn btn-primary" style={{ float: 'right', marginBottom: '10px' }} onClick={() => showRecord(!showModal)} >View Records</button>

                                {<Popconfirm
                                    title="Are you sure to submit this?"
                                    onConfirm={submitAirtimeDisbursement}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Submit</button>
                                </Popconfirm>}
                            </div>}

                            {/* {giveaways && giveaways.length > 0 && <div className="col-md-6">
                                    <h6>Pay with card : Fee = &#8358; {formatAmount(200 + (1.5*amount/100))}</h6>
                                    <h6>Amount + Fee = &#8358; {formatAmount((200 + (1.5*amount/100)) + amount)}</h6>
                                    {<PaystackButton {...componentProps} className="btn btn-success btn-block" />}
                                </div>} */}

                        </div>}
                    </Spin>




                </div>
            </ModalComponent>}

        </div>
    );

}

export default withRouter(AirtimeDetailPage);
